import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { translateFn } from '../../../../utils/translator.helper';
import { NetworkPopUpType } from '../../network.pop-up.factory';
import { GzUninstallAgentWebComponent } from './component/GzUninstallAgentWebComponent';
import { CreateTaskRequest } from '../../types';
import { FormGroupValue } from '../../../../ui/gzForm/formGroup/types/form-group-value';
import { UninstallTaskSpecifics } from './interfaces';
import { TaskType } from '../../../../tasks/networkTasks/types';

export class UninstallAgentPopUp extends NetworkBasePopUp<GzUninstallAgentWebComponent> {
  protected extraDialogConfigs: Partial<GzDialog>;
  protected title = translateFn('Uninstall agent');
  private type: NetworkPopUpType = NetworkPopUpType.UNINSTALL_AGENT;

  protected customSetup() {
    this.popUpContent = new GzUninstallAgentWebComponent();
    this.popUpFooterButtons = [
      {
        id: 'confirmButton',
        label: translateFn('Save#preserve state'),
      },
      {
        id: 'closeButton',
        label: translateFn('Cancel'),
      },
    ];
  }

  protected async handleConfirmButtonClicked(event: CustomEvent) {
    const popUpContent = this.popUpContent as GzUninstallAgentWebComponent;
    popUpContent.detachFormEventListeners();

    const formValue: FormGroupValue = popUpContent.getFormValue();

    if (!this.data.targets) {
      throw new Error('Targets are not defined');
    }

    const request: CreateTaskRequest<UninstallTaskSpecifics> = {
      settings: {
        specifics: this.prepareUninstallTaskPayload(formValue),
        taskName: this.getTaskName(),
        targets: this.data.targets,
        type: TaskType.TASK_TYPE_UNINSTALL_ENDPOINT_PARENT,
      },
    };

    await this.createTask<UninstallTaskSpecifics>(request);
  }

  private prepareUninstallTaskPayload(formValue: FormGroupValue): UninstallTaskSpecifics {
    return {
      keepQuarantine: !!formValue.keepQuarantinedItemsCheckbox,
      credentials: [], // Required for vShield integration in On-Prem
    };
  }

  private getTaskName(): string {
    return translateFn(`Uninstall Client {date}`, { date: new Date().toISOString().split('T')[0] });
  }

  protected handleCancelButtonClicked(event: CustomEvent): void {
    return;
  }
}
